import React from 'react';
import './Roadmap.css';

const Roadmap = ({ roadmap, onTopicSelect }) => {
  const renderTopic = (topic, level = 0) => {
    return (
      <div key={topic.id} className={`roadmap-topic level-${level}`}>
        <div 
          className="topic-content"
          onClick={() => onTopicSelect(topic.title)}
        >
          <h3>{topic.title}</h3>
          <p>{topic.description}</p>
        </div>
        {topic.subtopics && topic.subtopics.length > 0 && (
          <div className="subtopics">
            {topic.subtopics.map(subtopic => renderTopic(subtopic, level + 1))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="roadmap-container">
      <h2>Learning Roadmap</h2>
      <div className="roadmap-content">
        {roadmap.map(topic => renderTopic(topic))}
      </div>
    </div>
  );
};

export default Roadmap; 